import { IconCheck } from "@frontend/common";

import { useArticleInfoQuery } from "@api/articleInfo/useArticleInfo";
import { useSaveEditedArticle } from "@EditArticleContainer/shared/hooks/useSaveEditedArticle";
import { useMovePage } from "@hooks/useMovePage";
import { useUpdateArticleStatus } from "@hooks/useUpdateArticleStatus";
import { usePressIdFromURL } from "@utils/getStateFromURL";
import { toastArticlePublish, toastFail } from "@utils/toast";

import { useDisabledPublishButton } from "./hooks/useDisabledPublishButton";
import { usePublish } from "./hooks/usePublish";
import * as S from "./PublishButton.style";

const PublishButton = () => {
  const { saveArticleContent } = useSaveEditedArticle();
  const updateArticleStatus = useUpdateArticleStatus();
  const disabledPublishButton = useDisabledPublishButton();
  const movePage = useMovePage();
  const publish = usePublish();

  const handlePublishButtonClick = async () => {
    if (disabledPublishButton) {
      toastFail("Please select image before publishing.", "bottomLeft");
      return;
    }
    if (window.confirm("Are you sure you want to publish?") === false) return;
    await saveArticleContent();

    const publishedData = await publish();
    if (!publishedData || !publishedData.urlTitle) {
      return;
    }
    const { urlTitle } = publishedData;

    movePage("pressList");
    updateArticleStatus("published");
    toastArticlePublish(urlTitle);
  };

  const draftArticleId = usePressIdFromURL();
  const { data: articleInfo } = useArticleInfoQuery(Number(draftArticleId));

  const isDisabled = articleInfo?.draftArticleStatusHighest === "S930";

  return (
    <S.NextButton onClick={handlePublishButtonClick} disabled={isDisabled}>
      Publish
      <IconCheck
        width={20}
        height={20}
        color={isDisabled ? "#96A1B0" : "#fff"}
      />
    </S.NextButton>
  );
};

export default PublishButton;
